import { useEffect } from "react";

/**
 * Injects JSON-LD structured data into document head.
 * Cleans up on unmount to prevent duplicate schemas across routes.
 */
export default function SchemaMarkup({ id, schema }) {
  useEffect(() => {
    if (!schema) return;
    const scriptId = `ldjson-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schema);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [id, schema]);
  return null;
}
